export default "__VITE_ASSET__e0990b60__"